import cn from 'classnames';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import { HOME_CHEF, TEMPO } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import useBrand from 'hooks/useBrand';
import { SIGN_IN_PATH, TERMS_PATH, PRIVACY_POLICY_PATH } from 'lib/constants/routingConstants';

const SignInButtonSection = ({
  brand,
  isUcl,
  onClick,
  showConvenienceClaimSource,
  containerClassName = '',
  textClassName = '',
}) => {
  const isHomeChef = useBrand(HOME_CHEF);
  const brandName = brandData(brand)?.displayName;

  return (
    <div className={cn('mb-6 flex', containerClassName)}>
      <div className={cn('py-0', containerClassName)}>
        <Text
          brandStylesOverrides="text text-light"
          className={cn({ textSm: isHomeChef }, textClassName)}
        >
          By continuing, I accept the {brandName}
          <DefaultLink
            isExternal
            to={TERMS_PATH}
            className={cn('px-1 py-0  underline', textClassName)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions of Service
          </DefaultLink>
          and
          <DefaultLink
            isExternal
            to={PRIVACY_POLICY_PATH}
            className={cn('py-0 pl-1 pr-0  underline', textClassName)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </DefaultLink>
          .
        </Text>
        {!isUcl && (
          <Text
            brandStylesOverrides="text text-light"
            className={cn({ 'font-medium': isHomeChef }, 'pt-2 ', textClassName)}
          >
            Already have an account?
            <DefaultLink
              isExternal
              to={SIGN_IN_PATH}
              className={cn('py-0 pl-1 pr-0 underline', textClassName)}
              onClick={onClick}
            >
              Sign In
            </DefaultLink>
            .
          </Text>
        )}
        {showConvenienceClaimSource && (
          <Text className="textSm pt-4">
            *Source: We are Talker (fka 72Point Inc., OnePoll U.S. & SWNS Media Group), June 2024
          </Text>
        )}
      </div>
    </div>
  );
};

SignInButtonSection.propTypes = {
  brand: PropTypes.oneOf([HOME_CHEF, TEMPO]),
  isUcl: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  showConvenienceClaimSource: PropTypes.bool.isRequired,
  containerClassName: PropTypes.string,
  textClassName: PropTypes.string,
};

export default SignInButtonSection;
